// store/modules/orderGeneral/actions.js
import OrderGenaralApi from "../../../api/modules/OrderGeneralApi";

const searchOrderGeneral = (_, payload) => {
  return OrderGenaralApi.orderGenListWithFilter(payload.context, payload);
};

const downloadImportFile = (_, payload) => {
  return OrderGenaralApi.downloadImportFile(payload.context, payload.idOrderGeneral);
};

export default {
  searchOrderGeneral,
  downloadImportFile,
};



// WEBPACK FOOTER //
// ./src/store/modules/orderGeneral/actions.js